<template>
  <div class="answer-text" v-if="asAnswer">
    {{ researchItem.answer.value }}
  </div>
  <textarea
    v-else
    class="form-control form-control-lg bg-lightest p-3"
    v-model="researchItem.answer.value"
    ref="item"
    :style="{'min-height': `${researchItem.item.config.height}px`}"
    :id="itemId"
  />
</template>

<script>
import { GenericItemMixin } from '@/reviewer/mixins';

export default {
  name: 'ItemTextArea',
  mixins: [
    GenericItemMixin,
  ],
  computed: {
    itemId() {
      return this.idPrefix ? `${this.idPrefix}-item-text-area` : 'item-text-area';
    },
  },
  mounted() {
    if (this.$refs.item) {
      this.$refs.item.focus();
    }
  },
};
</script>

<style scoped>
.answer-text {
  white-space: pre-line;
}
</style>
